import { CodeError } from '@iotize/common/error';

export class ConverterError extends CodeError<ConverterError.Code> {
  constructor(
    code: ConverterError.Code,
    msg: string,
    public cause?: Error,
  ) {
    super(msg, code);
  }

  static unexpectedBufferSize(expected: number, buffer: Uint8Array) {
    return new ConverterError(
      ConverterError.Code.UnexpectedBufferSizeError,
      'Expected buffer of ' +
        expected +
        ' byte(s) but found only ' +
        buffer.length +
        ' byte(s)',
    );
  }

  static nullBufferError(msg: string) {
    return new ConverterError(ConverterError.Code.NullBufferError, msg);
  }

  static valueTooBigError(value: number, maxValue: number) {
    return new ConverterError(
      ConverterError.Code.ValueTooBigError,
      `Value ${value} is not acceptable. Maximum authorized value is ${maxValue}.`,
    );
  }
}

export namespace ConverterError {
  export enum Code {
    UnexpectedBufferSizeError = 'UnexpectedBufferSizeError',
    NullBufferError = 'NullBufferError',
    ValueTooBigError = 'ConverterErrorValueTooBigError',
  }
}
